


























import Vue, { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TableOfContents",
  components: {
    Heading
  },
  props: {
    limit: {
      type: Number as PropType<Props["limit"]>,
      default: 0
    },
    items: {
      type: Array as PropType<Props["items"]>,
      required: true,
      default: () => []
    }
  },
  computed: {
    slicedItems() {
      return this.limit ? this.items.slice(0, this.limit) : this.items;
    },
    ellipsisVisible() {
      return !!this.limit && this.items.length > this.limit;
    }
  },
  methods: {
    handleClick(url: string) {
      this.$emit("clickContent", url);
    }
  }
});
